<div class="boxed">
  <div class="site-card">
    <h1 [innerHTML]="imprintTxt.imprint_caption | i18next"></h1>
    <div [innerHTML]="imprintTxt.imprint_content"></div>
  </div>
</div>
